import {Button} from '@viptech/react-components'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import LogoutIcon from 'src/images/logoutSmallIcon.svg'
import {useAuth} from '../../../contexts/AuthContext'
import storage from '../../../services/storage'
import {HeaderContainer, HeaderExitButtonContainer, ImageContainer, ImageLogoutContainer} from './HeaderBase'

function Header() {
  const {logout} = useAuth()
  const {loginPagesLogo} = usePersonalizedThemeByCompany()

  const userLogged = storage.get('token')

  return (
    <HeaderContainer>
      <ImageContainer src={loginPagesLogo} alt='logo' onClick={() => (window.location.href = '/login')} />

      {userLogged && (
        <HeaderExitButtonContainer>
          <Button
            leftIcon={<ImageLogoutContainer src={LogoutIcon} alt='sair' />}
            color='transparent'
            onClick={() => {
              void logout()
            }}>
            Sair
          </Button>
        </HeaderExitButtonContainer>
      )}
    </HeaderContainer>
  )
}

export default Header
